var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "person") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4280",
    "data-name": "Group 4280",
    transform: "translate(-545 -197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4276",
    "data-name": "Group 4276",
    transform: "translate(-87.066 -86.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4275",
    "data-name": "Group 4275",
    transform: "translate(631.898 282.898)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_315",
    "data-name": "Ellipse 315",
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    transform: "translate(0.168 0.168)",
    fill: "#21a2ee"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_User_Wait_710812",
    "data-name": "noun_User Wait_710812",
    transform: "translate(11.656 11.657)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M39.989,34.148a5.406,5.406,0,0,0-2.352.535,10.026,10.026,0,0,0-2.754-1.457,6.613,6.613,0,1,0-6.536.026A10.1,10.1,0,0,0,21.6,42.778h1.417a8.662,8.662,0,0,1,8.633-8.671,8.547,8.547,0,0,1,4.724,1.419,5.437,5.437,0,1,0,3.614-1.378ZM26.4,27.494a5.2,5.2,0,1,1,5.2,5.2A5.2,5.2,0,0,1,26.4,27.494ZM39.989,43.613a4.024,4.024,0,1,1,4.023-4.023A4.028,4.028,0,0,1,39.989,43.613Z",
    transform: "translate(-21.601 -20.88)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M97.865,89.082H96.448v3.365l2.019,2.019,1-1-1.6-1.6Z",
    transform: "translate(-78.769 -72.972)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.d9f33b3743af2acd731e11c6ab28b0be.svg";
export { ForwardRef as ReactComponent };